import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia enseñando?',
    a: 'No. El sistema está diseñado para padres sin experiencia docente. Cada actividad viene con instrucciones claras paso a paso.'
  }, {
    q: '¿Cuánto tiempo necesito dedicarle?',
    a: 'Solo 10 minutos diarios. Las actividades están diseñadas para ser cortas y efectivas, sin agotar la atención de tu hijo.'
  }, {
    q: '¿El material es digital o físico?',
    a: 'Es 100% digital con descarga inmediata. Podés imprimir las actividades desde tu casa las veces que necesites.'
  }, {
    q: '¿Para qué edades funciona?',
    a: 'Está diseñado para niños de 3 a 7 años que están iniciando o tienen dificultades con la lectura.'
  }, {
    q: '¿Qué pasa si no funciona para mi hijo?',
    a: 'Tenés garantía de satisfacción. Podés revisar todo el material con tranquilidad y si no es lo que esperabas, te devolvemos tu dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-white via-kid-purple/5 to-kid-pink/5 relative overflow-hidden" data-id="element-108">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-109">
        <FadeIn data-id="element-110">
          <div className="text-center mb-8 md:mb-16" data-id="element-111">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-112">
              PREGUNTAS FRECUENTES
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-purple via-kid-pink to-kid-sky mx-auto rounded-full" data-id="element-113"></div>
          </div>
        </FadeIn>

        <div className="space-y-2.5 md:space-y-3" data-id="element-114">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-115">
              <div className={`border rounded-xl overflow-hidden transition-all duration-200 ${openIndex === idx ? 'border-kid-purple shadow-sm bg-white' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-116">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 md:px-6 py-3 md:py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-117">
                  <span className="font-medium text-sm md:text-base text-gray-900" data-id="element-118">
                    {faq.q}
                  </span>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-200 ${openIndex === idx ? 'bg-kid-purple/10' : 'bg-gray-100'}`} data-id="element-119">
                    <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openIndex === idx ? 'rotate-180 text-kid-purple' : 'text-gray-400'}`} data-id="element-120" />
                  </div>
                </button>
                <div className={`px-5 md:px-6 overflow-hidden transition-all duration-200 ease-in-out ${openIndex === idx ? 'max-h-40 pb-3 md:pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-121">
                  <p className="text-gray-500 text-sm md:text-base" data-id="element-122">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}